export class UrlHelper {
  public static GetParameter(name: string): string | null {

    let arr = window.location.href.split('?')

    if (arr.length < 2)
      return null;

    var params = arr[1].split('&');

    for (var i = 0; i < params.length; i++) {
      let arr = params[i].split('=');
      if (arr[0] == name)
        return arr[1];
    }

    return null;
  }

  public static GetNumberFromParameter = (name: string): number | null => {
    const param = UrlHelper.GetParameter(name);
    if (param) {
      const num = Number(param);
      if (!isNaN(num)) {
        return num;
      }
    }
    return null;
  };
}
